import { SKILLS_ROUTES } from '../../constants/_routes'
import skillsTypes from '../../constants/skillsTypes'
import { axios } from '../../services'

// INDEX
const skills_index_request = () => {
  return {
    type: skillsTypes.index.request
  }
}

const skills_index_success = (response) => {
  return {
    type: skillsTypes.index.success,
    payload: response.data
  }
}

const skills_index_failure = (messages) => {
  return {
    type: skillsTypes.index.failure,
    payload: messages
  }
}

const skills_index = () => {
  return function (dispatch) {
    // Before Request
    dispatch(skills_index_request())

    // Request
    axios.get(
      SKILLS_ROUTES.index
    ).then( response => {
      // success
      dispatch( skills_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching skills."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( skills_index_failure(errors))
    })
  }

}

export {
  skills_index
}



// WEBPACK FOOTER //
// ./src/js/actions/skills/getindex.js